<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import request from "@/lib/request.js";
export default {
  name: "App",
  provide() {
    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      isRouterAlive: true //控制视图是否显示的变量
    };
  },
  methods: {
    ...mapMutations(["setChangWidth"]),
    ...mapMutations("tenant", ["INIT_TENANT_INFO"]),
    reload() {
      this.isRouterAlive = false; //先关闭，
      this.$nextTick(function() {
        this.isRouterAlive = true; //再打开
      });
    }
  },
  async mounted() {
    if (document.body.clientWidth < 1000) {
      this.setChangWidth(true);
    }
    const tenantId = localStorage.getItem("shopId");
    if(tenantId) {
      //初始化租户信息
      const { data } = await request.get("/hopTenantInfo/getInfo", {});
      if (data && data.code == 200) {
        this.INIT_TENANT_INFO(data.data || {});
      }
    }

  }
};
</script>

<style>
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue